import React from "react";
import { Box, Button } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";
import { api } from "common";
import { colors } from "./Theme/WebTheme";
import { FONT_FAMILY } from "../common/sharedFunctions";
import { ErrorState } from "./adminPrimitives";

const BookingDataLoadError = ({ message }) => {
  const dispatch = useDispatch();
  const safeMessage = message || "Unable to load booking data.";

  const handleRetry = () => {
    dispatch(api.fetchBookings());
  };

  return (
    <Box
      role="alert"
      aria-live="polite"
      sx={{
        m: 3,
        p: 3,
        maxWidth: 680,
        borderRadius: 2,
        border: "1px solid #F4C7C3",
        backgroundColor: "#FFF7F6",
        boxShadow: "0 8px 24px rgba(16, 46, 86, 0.08)"
      }}
    >
      <ErrorState
        title={safeMessage}
        description="Please refresh the page or contact the system administrator."
        action={
          <Button
            variant="contained"
            startIcon={<ReplayIcon />}
            onClick={handleRetry}
            sx={{
              backgroundColor: colors.Action_Button_Back,
              color: colors.Header_Background,
              fontFamily: FONT_FAMILY,
              fontWeight: 800,
              textTransform: "none",
              borderRadius: 999,
              "&:hover": {
                backgroundColor: colors.Action_Button_Back
              }
            }}
          >
            Retry
          </Button>
        }
      />
    </Box>
  );
};

export default BookingDataLoadError;
